export default __webpack_public_path__ + "static/media/header-xs-2x.fe153a63.webp";